import axios from 'axios';

export const axiosUploadFile = async (signedUrl: string, file: any) => {
  const type =
    file.type && file.type !== '' ? file.type : 'application/octet-stream';
  return axios.put(signedUrl, file, {
    headers: {
      'Content-Type': type,
    },
  });
};

export const fileBlobToDataUrl = (file: File): Promise<string> => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException('Cannot convert file'));
    };
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data ? base64data.toString() : '');
    };
  });
};

export const base64toBlob = (
  b64Data: string,
  contentType: string,
  sliceSize?: number,
): any => {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const fileToBase64 = (file: File | Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob)) {
      reject(new TypeError('Input must be a Blob or File'));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result as string;
      resolve(base64String);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};
